export default __webpack_public_path__ + "static/clutch-logo-4fdfb73162ba5d9b6c4913ceac9952bf.svg";